import { defineMessages } from 'react-intl';

export default defineMessages({
  courtManagerConfirmationDialogTitle: {
    id:
      'court_manager_legal_proceedings_page.judgement_add.confirmation_dialog.title',
  },
  courtManagerConfirmationDialogCancel: {
    id:
      'court_manager_legal_proceedings_page.judgement_add.confirmation_dialog.cancel',
  },
  courtManagerConfirmationDialogConfirm: {
    id:
      'court_manager_legal_proceedings_page.judgement_add.confirmation_dialog.confirm',
  },
  validateAfterRejectionTitle: {
    id:
      'court_manager_legal_proceedings_page.judgement_on_merits.validation_after_reject.title',
  },
  invalidDate: {
    id: 'preopening_page.invalid_date',
  },
});
